<script setup lang="ts">
import { ref } from 'vue'
const props = defineProps<{ header?: string }>()
const visible = ref(false)
</script>
<template>
  <Button class="info-button" icon="pi pi-info-circle" @click="visible = true" />
  <Dialog v-model:visible="visible" modal :header="props.header" :style="{ width: '50vw' }">
    <slot></slot>
  </Dialog>
</template>
<style lang="scss" scoped>
.info-button {
  height: 44px;
  width: 44px;
  min-width: 44px;
  background: transparent;
  color: black;
  border: none;
  margin-left: 0.5rem;

  &:focus-visible {
    border: 2px solid #2196f3;
    box-shadow: 0 0 0 0.2rem #a6d5fa !important;
  }
}
</style>
